import React, { useEffect, useRef, useState, useCallback } from 'react';
import arrowLeftSvg from '../../assets/images/blogs/svg/leftArrow.svg';
import arrowRightSvg from '../../assets/images/blogs/svg/rightArrow.svg';
import { IndicatorsSvg } from '../../components/WhatMakesSvg';
import blog1 from '../../assets/images/blogs/png/blog1.png'
import blog2 from '../../assets/images/blogs/png/blog2.png'
import blog3 from '../../assets/images/blogs/png/blog3.png'
import blog4 from '../../assets/images/blogs/png/blog4.png'
import blog5 from '../../assets/images/blogs/png/blog5.png'
import blog6 from '../../assets/images/blogs/png/blog6.png'
import blog7 from '../../assets/images/blogs/png/blog7.png'


const Blogs = () => {
    const scrollContainer = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [screenSize, setScreenSize] = useState('large');

    const blogsData = [
        {
            image: blog1,
            author: 'Alec Whitten',
            date: '02 Sept 2024',
            title: 'Why Combine Accidental Coverage with Health Insurance?',
            description: "In today's fast-paced world, accidents and unexpected health issues are a reality that many people face.",
            url: 'https://www.manipalcigna.com/blog/benefits-of-combining-accidental-coverage-with-health-insurance'
        },
        {
            image: blog2,
            author: 'Alec Whitten',
            date: '02 Sept 2024',
            title: 'Total Temporary Disability: Benefits, Features & How It Works',
            description: 'In the face of unexpected accidents or illnesses, the ability to sustain your income while you’re temporarily unable to work can be crucial.',
            url: 'https://www.manipalcigna.com/blog/total-temporary-disability-guide'
        },
        {
            image: blog3,
            author: 'Alec Whitten',
            date: '29 Aug 2024',
            title: 'Health Insurance Waiting Periods: What You Need to Know',
            description: 'Health insurance is an essential aspect of life. It provides a financial safety net in times of medical emergencies.',
            url: 'https://www.manipalcigna.com/blog/health-insurance-waiting-periods'
        },
        {
            image: blog4,
            author: 'Alec Whitten',
            date: '29 Aug 2024',
            title: 'Maternity Benefit in Health Insurance',
            description: 'What is Maternity Benefit in Health Insurance? Maternity Benefits in Health Insurance refer to coverage specifically for pregnancy and childbirth related medical expenses.',
            url: 'https://www.manipalcigna.com/blog/top-8-maternity-benefits-in-health-insurance'
        },
        {
            image: blog5,
            author: 'Alec Whitten',
            date: '29 Aug 2024',
            title: 'Top 4 Benefits of Regular Health Checkups | ManipalCigna',
            description: "It's easy to assume we're in good health and overlook the need for regular check-ups.",
            url: 'https://www.manipalcigna.com/blog/top-4-benefits-of-regular-health-checkups'
        },
        {
            image: blog6,
            author: 'Alec Whitten',
            date: '29 Aug 2024',
            title: 'A Comprehensive Checklist for First-Time Health Insurance Buyers',
            description: 'Health insurance is a financial product that protects you from medical expenses that may be beyond your means.',
            url: 'https://www.manipalcigna.com/blog/checklist-for-first-time-health-insurance-buyers'
        },
        {
            image: blog7,
            author: 'Alec Whitten',
            date: '29 Aug 2024',
            title: 'Top 12 Essential Covers to Look Out for in a Health Insurance Plan',
            description: 'Choosing the right health insurance plan is crucial for ensuring complete protection and peace of mind.',
            url: 'https://www.manipalcigna.com/blog/12-things-to-consider-before-buying-health-insurance'
        },
    ];

    const getCardsPerView = useCallback(() => {
        switch (screenSize) {
            case 'small': return 1;
            case 'medium': return 2;
            case 'large': return 3;
            case 'extraLarge': return 4;
            default: return 4;
        }
    }, [screenSize]);

    const updateScreenSize = useCallback(() => {
        const width = window.innerWidth;
        if (width < 640) setScreenSize('small');
        else if (width < 1024) setScreenSize('medium');
        else if (width < 1440) setScreenSize('large');
        else setScreenSize('extraLarge');
    }, []);

    useEffect(() => {
        updateScreenSize();
        window.addEventListener('resize', updateScreenSize);
        return () => window.removeEventListener('resize', updateScreenSize);
    }, [updateScreenSize]);

    const scroll = useCallback((direction) => {
        const { current } = scrollContainer;
        if (current) {
            const cardsPerView = screenSize === 'small' ? 1 : getCardsPerView();
            const containerWidth = current.offsetWidth;
            const cardWidth = containerWidth / cardsPerView;
            const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;

            let newScrollLeft = current.scrollLeft + scrollAmount;
            const maxScrollLeft = current.scrollWidth - containerWidth;

            if (newScrollLeft < 0) newScrollLeft = maxScrollLeft;
            if (newScrollLeft > maxScrollLeft) newScrollLeft = 0;

            current.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });

            const newIndex = Math.round(newScrollLeft / cardWidth);
            setActiveIndex(newIndex % blogsData.length);
        }
    }, [getCardsPerView, blogsData.length, screenSize]);

    useEffect(() => {
        const interval = setInterval(() => {
            scroll('right');
        }, 5000);

        return () => clearInterval(interval);
    }, [scroll]);

    const handleManualScroll = (direction) => {
        scroll(direction);
    };

    const handleScroll = useCallback(() => {
        const { current } = scrollContainer;
        if (current) {
            const cardsPerView = getCardsPerView();
            const cardWidth = current.offsetWidth / cardsPerView;
            const newIndex = Math.round(current.scrollLeft / cardWidth);
            setActiveIndex(newIndex % blogsData.length);
        }
    }, [getCardsPerView, blogsData.length]);

    useEffect(() => {
        const { current } = scrollContainer;
        if (current) {
            current.addEventListener('scroll', handleScroll);
            return () => current.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    return (
        <div className="px-4 md:px-8 lg:px-[120px] py-12 lg:py-20 w-full relative">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
                Read Our Blogs
            </h1>
            <div className="flex items-center justify-center">
                {screenSize !== 'small' && (
                    <button
                        onClick={() => handleManualScroll('left')}
                        className="absolute left-2 md:left-4 lg:left-8 rounded-full text-white"
                    >
                        <img src={arrowLeftSvg} alt="arrow-left" className='h-8 w-8 md:h-10 md:w-10 lg:h-12 lg:w-12' />
                    </button>
                )}
                <div
                    ref={scrollContainer}
                    className="flex overflow-x-auto space-x-4 w-full no-scrollbar"
                    style={{
                        scrollSnapType: 'x mandatory',
                        scrollBehavior: 'smooth',
                        WebkitOverflowScrolling: 'touch', // For iOS momentum scrolling
                    }}
                >
                    {blogsData.map((blog, index) => (
                        <div
                            key={index}
                            className={`flex-shrink-0 rounded-2xl overflow-hidden bg-[#F3F3F3] transition-transform duration-300 ease-in-out cursor-pointer`}
                            style={{
                                width: screenSize === 'small' ? '100%' : `calc(${100 / getCardsPerView()}% - ${(getCardsPerView() - 1) * 16 / getCardsPerView()}px)`,
                                scrollSnapAlign: screenSize === 'small' ? 'center' : 'start'
                            }}
                            onClick={() => window.open(blog.url, '_blank', 'noopener,noreferrer')}
                        >
                            <img
                                src={blog.image}
                                alt={`Blog ${index + 1}`}
                                className="w-full object-cover rounded-xl aspect-[1.558]"
                            />
                            <div className="py-4 px-3 flex flex-col gap-2">
                                <p className="text-xs leading-[10.78px] text-black opacity-60 font-normal">
                                    {blog.date}
                                </p>
                                <h3 className="text-xl font-medium leading-[26px]">
                                    {blog.title}
                                </h3>
                                <p className="text-black text-sm leading-[22px] line-clamp-2 font-normal opacity-60">
                                    {blog.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                {screenSize !== 'small' && (
                    <button
                        onClick={() => handleManualScroll('right')}
                        className="absolute right-2 md:right-4 lg:right-8 rounded-full text-white"
                    >
                        <img src={arrowRightSvg} alt="arrow-right" className='h-8 w-8 md:h-10 md:w-10 lg:h-12 lg:w-12' />
                    </button>
                )}
            </div>
            {screenSize === 'small' && (
                <div className='flex flex-col items-center justify-between gap-5 mt-6 w-full'>
                    <div className='flex flex-row items-center justify-center gap-2'>
                        {[...Array(Math.ceil(blogsData.length / getCardsPerView()))].map((_, i) => (
                            <button
                                key={i}
                                onClick={() => {
                                    const { current } = scrollContainer;
                                    if (current) {
                                        const cardWidth = current.offsetWidth / getCardsPerView();
                                        current.scrollTo({
                                            left: i * getCardsPerView() * cardWidth,
                                            behavior: 'smooth'
                                        });
                                    }
                                }}
                                aria-label={`Go to slide ${i + 1}`}
                                aria-current={i === Math.floor(activeIndex / getCardsPerView()) ? "true" : "false"}
                            >
                                <IndicatorsSvg
                                    fill={i === Math.floor(activeIndex / getCardsPerView()) ? '#0B497A' : '#CEDBE4'}
                                />
                            </button>
                        ))}
                    </div>
                    <a href="https://www.manipalcigna.com/blog" target='_blank' className="bg-[#FB7C2F] text-xl leading-[23px] font-normal rounded-xl text-white p-4 w-[80%] text-center">View all Blogs</a>
                </div>
            )}
            {screenSize !== 'small' && (
                <div className="text-center pt-6">
                    <a href="https://www.manipalcigna.com/blog" target='_blank' className="text-[#FB7C2F] underline">View all Blogs</a>
                </div>
            )}
        </div>
    );
};

export default Blogs;
